import React, { useContext } from "react";
import "./contact.css";
import { useRef, useState } from "react";
import emailjs from "emailjs-com";
// https://dashboard.emailjs.com/admin
import { ThemeContext } from "../../context";
import Lottie from "lottie-react";
import animationData from "../../lottie/l2.json";

const Contact = () => {
  const formRef = useRef();
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;

  const handleSubmit = (e) => {
    e.preventDefault();

    const form = formRef.current;
    const name = form.user_name.value;
    const email = form.user_email.value;
    const message = form.message.value;

    if (!name || !email || !message) {
      setError("Please fill out all the fields before submitting.");
      return;
    }

    setError("");

    emailjs
      .sendForm(
        "service_rp9u97c",
        "template_kzpnkf1",
        formRef.current,
        "vmvP68izNSGuljOCq"
      )
      .then(
        (result) => {
          console.log(result.text);
          setDone(true);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div className="c">
      <div className="c-wrapper">
        <div className="c-left">
          <Lottie
            animationData={animationData}
            loop={true}
            className="i-lottie"
          />
        </div>
        <div className="c-right">
          <p className="c-desc">
            <h1>Let's Connect</h1>
            <div className="c-line"></div>I live in Boston, but I would be more
            than happy to relocate anywhere in the United States if the role
            interests me!
          </p>
          <form ref={formRef} onSubmit={handleSubmit}>
            <input
              style={{ backgroundColor: darkMode && "#fff" }}
              type="text"
              placeholder="Name"
              name="user_name"
            />
            <input
              style={{ backgroundColor: darkMode && "#fff" }}
              type="text"
              placeholder="Email"
              name="user_email"
            />
            <textarea
              style={{ backgroundColor: darkMode && "#fff" }}
              rows="6"
              placeholder="Message"
              name="message"
            />
            <button>Send Message</button>
            {done && (
              <p>Thank you for your message, I will get back to you soon! 😊</p>
            )}
            {error && <p className="error">{error}</p>}
          </form>
        </div>
      </div>
    </div>
  );
};
export default Contact;
